import React, { useEffect, useState } from "react"
import ScaleLoader from "react-spinners/ScaleLoader"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import { RootState } from "../../store"
import { loadDrops, resetSuccess } from "../../store/drop.store"
import Header from "../Layout/Header"
import DropTable from "./DropsTable"

const Drop = () => {
    const { userInfo, defaultWarehouse } = useAppSelector((state: RootState) => state.auth)
    const { drops, loading, success } = useAppSelector((state: RootState) => state.drops)
    const [parcelIds, setParcelIds] = useState([] as number[])
    const { selectedWarehouse } = useAppSelector((state: RootState) => state.warehouses)
    //Date Picker Logic
    const [startDate, setStartDate] = useState()
    const [endDate, setEndDate] = useState()
    const dispatch = useAppDispatch()

    //useEffect(() => {
    //    const dateObj2 = {
    //        start_date: startDate ? moment(startDate).format("YYYY-MM-DD") : "2020-04-15",
    //        end_date: endDate ? moment(endDate).format("YYYY-MM-DD") :moment().add(1,'days').format("YYYY-MM-DD"),
    //    };

    //}, [endDate]);

    useEffect(() => {
        dispatch(
            loadDrops({
                warehouse: selectedWarehouse?.toString()
            })
        )
    }, [])

    useEffect(() => {
        if (success) {
            dispatch(
                loadDrops({
                    warehouse: selectedWarehouse?.toString()
                })
            )
            dispatch(resetSuccess())
        }
    }, [success, selectedWarehouse])

    return (
        <>
            {loading || !userInfo?.accessToken ? (
                <div className="loader row justify-content-center">
                    <ScaleLoader color="#15397F" width={4} height={40} />
                </div>
            ) : (
                <div className="drop">
                    <Header
                        title="Drop"
                        records={drops.length}
                        data={drops}
                        name="Drop"
                        //buttonId="#dropExportButton"
                    >
                        <div className="mx-2">
                            {/*<DateRangePickerCustom setStartDate={setStartDate} setEndDate={setEndDate} />*/}
                        </div>
                    </Header>
                    <div className="row d-flex px-2">
                        <DropTable drops={drops} />
                    </div>
                </div>
            )}
        </>
    )
}

export default Drop
